import type { APIFieldAttributes, APIModelAttributes } from '@ardoq/api-types';
import { workspaceInterface } from '@ardoq/workspace-interface';

const isTemplateModel = (model: APIModelAttributes | null): boolean =>
  Boolean(model?.common || model?.useAsTemplate);

const isNonTemplateField = (field: APIFieldAttributes): boolean => {
  const workspaceId = workspaceInterface.getWorkspaceIdByModelId(field.model);
  if (!workspaceId) return true;
  return !isTemplateModel(workspaceInterface.getModelData(workspaceId));
};

export const getNonTemplateFieldsByName = (
  fieldsByName: Map<string, APIFieldAttributes>
): Map<string, APIFieldAttributes> => {
  const result = new Map<string, APIFieldAttributes>();
  for (const [name, field] of fieldsByName) {
    if (isNonTemplateField(field)) result.set(name, field);
  }
  return result;
};
